import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Api} from 'src/smoothr-web-app-core/api/api';
import Order from 'src/smoothr-web-app-core/models/Order';
import Table from 'src/smoothr-web-app-core/models/Table';
import Venue from 'src/smoothr-web-app-core/models/Venue';

@Component({
	selector: 'app-select-table-checkout',
	templateUrl: './select-table-checkout.component.html',
	styleUrls: ['./select-table-checkout.component.scss']
})
export class SelectTableCheckoutComponent implements OnInit, OnDestroy {
	private ngOnDestroy$ = new Subject<void>();
	public venue: Venue;
	@Input() order: Order;
	@Input() set venueValue(value: Venue) {
		this.venue = value;
		this.loadTables(value);
	}
	@Output() outTable = new EventEmitter<Table>();
	public allTables: Table[] = [];
	public selectedTable = new FormControl();
	constructor(private snackBar: MatSnackBar) {}

	ngOnInit() {
		this.selectedTable?.valueChanges.pipe(takeUntil(this.ngOnDestroy$)).subscribe(it => {
			if (it) {
				const foundTable = this.allTables.find(table => table?._id === it);
				if (foundTable) {
					this.outTable.emit(foundTable);
				}
			}
		});
	}
	ngOnDestroy(): void {
		this.ngOnDestroy$.next();
	}
	async loadTables(venue: Venue) {
		if (venue && this.order) {
			try {
				const allTables = (await Api.getTablesByVenue(venue._id)).data.filter(
					v => v?.number !== 'system_table' && v?.number !== 'preorder_table'
				);
				if (allTables.length > 0) {
					this.allTables = allTables;
					this.selectedTable.patchValue(this.order?.table);
				}
			} catch (e) {
				console.log(e);
			}
		}
	}
}
